"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _Frame = _interopRequireDefault(require("./Frame"));

var _dataFunctions = require("./data/dataFunctions");

var _frame_props = require("./constants/frame_props");

var _networkframeRules = require("./annotationRules/networkframeRules");

var _baseRules = require("./annotationRules/baseRules");

var _functions = require("./generic_utilities/functions");

var _d3Scale = require("d3-scale");

var _network = require("./processing/network");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var blankArray = [];
var matrixRenderOrder = ["nodes", "edges"];
var generalRenderOrder = ["edges", "nodes"];
var projectedCoordinateNames = {
  y: "y",
  x: "x"
};
var xScale = (0, _d3Scale.scaleLinear)();
var yScale = (0, _d3Scale.scaleLinear)();

var NetworkFrame =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NetworkFrame, _React$Component);

  function NetworkFrame(props) {
    var _this;

    _classCallCheck(this, NetworkFrame);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NetworkFrame).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "defaultNetworkSVGRule", function (_ref) {
      var baseD = _ref.d,
          i = _ref.i,
          annotationLayer = _ref.annotationLayer;
      var _this$state = _this.state,
          projectedNodes = _this$state.projectedNodes,
          projectedEdges = _this$state.projectedEdges,
          nodeIDAccessor = _this$state.nodeIDAccessor,
          nodeSizeAccessor = _this$state.nodeSizeAccessor,
          networkFrameRender = _this$state.networkFrameRender,
          adjustedSize = _this$state.adjustedSize,
          adjustedPosition = _this$state.adjustedPosition; //TODO PASS FRAME STYLE FNs TO HIGHLIGHT

      var svgAnnotationRules = _this.props.svgAnnotationRules;
      var d = baseD.ids ? baseD : baseD.edge ? _objectSpread({}, projectedEdges.find(function (p) {
        return nodeIDAccessor(p.source) === nodeIDAccessor(baseD.source) && nodeIDAccessor(p.target) === nodeIDAccessor(baseD.target);
      }) || {}, baseD) : _objectSpread({}, projectedNodes.find(function (p) {
        return nodeIDAccessor(p) === baseD.id;
      }) || {}, baseD);
      var voronoiHover = annotationLayer.voronoiHover;

      if (svgAnnotationRules) {
        var customAnnotation = svgAnnotationRules({
          d: d,
          i: i,
          networkFrameProps: _this.props,
          networkFrameState: _this.state,
          nodes: projectedNodes,
          edges: projectedEdges,
          voronoiHover: voronoiHover,
          screenCoordinates: [d.x, d.y],
          adjustedPosition: adjustedPosition,
          adjustedSize: adjustedSize,
          annotationLayer: annotationLayer
        });

        if (customAnnotation !== null) {
          return customAnnotation;
        }
      }

      if (d.type === "node") {
        return (0, _networkframeRules.svgNodeRule)({
          d: d,
          i: i,
          nodeSizeAccessor: nodeSizeAccessor
        });
      } else if (d.type === "desaturation-layer") {
        return (0, _baseRules.desaturationLayer)({
          style: d.style instanceof Function ? d.style(d, i) : d.style,
          size: adjustedSize,
          i: i,
          key: d.key
        });
      } else if (d.type === "basic-node-label") {
        return React.createElement("g", {
          key: d.key || "basic-".concat(i),
          transform: "translate(".concat(d.x, ",").concat(d.y, ")")
        }, baseD.element || baseD.label);
      } else if (d.type === "react-annotation" || typeof d.type === "function") {
        return (0, _networkframeRules.svgReactAnnotationRule)({
          d: d,
          i: i,
          projectedNodes: projectedNodes,
          nodeIDAccessor: nodeIDAccessor
        });
      } else if (d.type === "enclose") {
        return (0, _networkframeRules.svgEncloseRule)({
          d: d,
          i: i,
          projectedNodes: projectedNodes,
          nodeIDAccessor: nodeIDAccessor,
          nodeSizeAccessor: nodeSizeAccessor
        });
      } else if (d.type === "enclose-rect") {
        return (0, _networkframeRules.svgRectEncloseRule)({
          d: d,
          i: i,
          projectedNodes: projectedNodes,
          nodeIDAccessor: nodeIDAccessor,
          nodeSizeAccessor: nodeSizeAccessor
        });
      } else if (d.type === "enclose-hull") {
        return (0, _networkframeRules.svgHullEncloseRule)({
          d: d,
          i: i,
          projectedNodes: projectedNodes,
          nodeIDAccessor: nodeIDAccessor,
          nodeSizeAccessor: nodeSizeAccessor
        });
      } else if (d.type === "highlight") {
        return (0, _networkframeRules.svgHighlightRule)({
          d: d,
          i: i,
          networkFrameRender: networkFrameRender
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "defaultNetworkHTMLRule", function (_ref2) {
      var baseD = _ref2.d,
          i = _ref2.i,
          annotationLayer = _ref2.annotationLayer;
      var _this$props = _this.props,
          tooltipContent = _this$props.tooltipContent,
          optimizeCustomTooltipPosition = _this$props.optimizeCustomTooltipPosition,
          htmlAnnotationRules = _this$props.htmlAnnotationRules,
          useSpans = _this$props.useSpans;
      var _this$state2 = _this.state,
          projectedNodes = _this$state2.projectedNodes,
          projectedEdges = _this$state2.projectedEdges,
          nodeIDAccessor = _this$state2.nodeIDAccessor,
          adjustedSize = _this$state2.adjustedSize,
          adjustedPosition = _this$state2.adjustedPosition;
      var voronoiHover = annotationLayer.voronoiHover;
      var d = baseD.ids ? baseD : baseD.edge ? _objectSpread({}, projectedEdges.find(function (p) {
        return nodeIDAccessor(p.source) === nodeIDAccessor(baseD.source) && nodeIDAccessor(p.target) === nodeIDAccessor(baseD.target);
      }) || {}, baseD) : _objectSpread({}, projectedNodes.find(function (p) {
        return nodeIDAccessor(p) === baseD.id;
      }) || {}, baseD);

      if (htmlAnnotationRules) {
        var customAnnotation = htmlAnnotationRules({
          d: d,
          i: i,
          networkFrameProps: _this.props,
          networkFrameState: _this.state,
          nodes: projectedNodes,
          edges: projectedEdges,
          voronoiHover: voronoiHover,
          screenCoordinates: [d.x, d.y],
          adjustedPosition: adjustedPosition,
          adjustedSize: adjustedSize,
          annotationLayer: annotationLayer
        });

        if (customAnnotation !== null) {
          return customAnnotation;
        }
      }

      if (d.type === "frame-hover") {
        return (0, _networkframeRules.htmlFrameHoverRule)({
          d: d,
          i: i,
          tooltipContent: tooltipContent,
          optimizeCustomTooltipPosition: optimizeCustomTooltipPosition,
          useSpans: useSpans,
          nodes: projectedNodes,
          edges: projectedEdges,
          nodeIDAccessor: nodeIDAccessor
        });
      }

      return null;
    });

    Object.keys(props).forEach(function (propName) {
      if (!_frame_props.networkframeproptypes[propName]) {
        if (_frame_props.xyframeproptypes[propName]) {
          console.error("".concat(propName, " is an XYFrame prop are you sure you're using the right frame?"));
        } else if (_frame_props.ordinalframeproptypes[propName]) {
          console.error("".concat(propName, " is an OrdinalFrame prop are you sure you're using the right frame?"));
        } else {
          console.error("".concat(propName, " is not a valid NetworkFrame prop"));
        }
      }
    });
    var baseState = {
      dataVersion: undefined,
      nodeData: [],
      edgeData: [],
      adjustedPosition: [],
      adjustedSize: [],
      backgroundGraphics: null,
      foregroundGraphics: null,
      projectedNodes: [],
      projectedEdges: [],
      renderNumber: 0,
      nodeLabelAnnotations: [],
      graphSettings: {
        type: "empty-start",
        nodes: [],
        edges: [],
        nodeHash: new Map(),
        edgeHash: new Map(),
        hierarchicalNetwork: false
      },
      edgeWidthAccessor: (0, _dataFunctions.stringToFn)("weight"),
      legendSettings: undefined,
      margin: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      },
      networkFrameRender: {},
      nodeIDAccessor: (0, _dataFunctions.stringToFn)("id"),
      nodeSizeAccessor: (0, _functions.genericFunction)(5),
      overlay: [],
      projectedXYPoints: [],
      sourceAccessor: (0, _dataFunctions.stringToFn)("source"),
      targetAccessor: (0, _dataFunctions.stringToFn)("target"),
      title: {
        title: undefined
      },
      props: props
    };
    _this.state = _objectSpread({}, baseState, (0, _network.calculateNetworkFrame)(props, baseState));
    return _this;
  }

  _createClass(NetworkFrame, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var onUnmount = this.props.onUnmount;

      if (onUnmount) {
        onUnmount(this.props, this.state);
      }
    }
  }, {
    key: "onNodeClick",
    value: function onNodeClick(d, i) {
      var onNodeClick = this.props.onNodeClick;

      if (onNodeClick) {
        onNodeClick(d, i);
      }
    }
  }, {
    key: "onNodeEnter",
    value: function onNodeEnter(d, i) {
      var onNodeEnter = this.props.onNodeEnter;

      if (onNodeEnter) {
        onNodeEnter(d, i);
      }
    }
  }, {
    key: "onNodeOut",
    value: function onNodeOut(d, i) {
      var onNodeOut = this.props.onNodeOut;

      if (onNodeOut) {
        onNodeOut(d, i);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          annotations = _this$props2.annotations,
          annotationSettings = _this$props2.annotationSettings,
          className = _this$props2.className,
          customClickBehavior = _this$props2.customClickBehavior,
          customDoubleClickBehavior = _this$props2.customDoubleClickBehavior,
          customHoverBehavior = _this$props2.customHoverBehavior,
          size = _this$props2.size,
          matte = _this$props2.matte,
          hoverAnnotation = _this$props2.hoverAnnotation,
          beforeElements = _this$props2.beforeElements,
          afterElements = _this$props2.afterElements,
          interaction = _this$props2.interaction,
          disableContext = _this$props2.disableContext,
          canvasPostProcess = _this$props2.canvasPostProcess,
          baseMarkProps = _this$props2.baseMarkProps,
          useSpans = _this$props2.useSpans,
          canvasNodes = _this$props2.canvasNodes,
          canvasEdges = _this$props2.canvasEdges,
          additionalDefs = _this$props2.additionalDefs,
          _this$props2$renderOr = _this$props2.renderOrder,
          renderOrder = _this$props2$renderOr === void 0 ? this.state.graphSettings && this.state.graphSettings.type === "matrix" ? matrixRenderOrder : generalRenderOrder : _this$props2$renderOr,
          sketchyRenderingEngine = _this$props2.sketchyRenderingEngine,
          frameRenderOrder = _this$props2.frameRenderOrder,
          disableCanvasInteraction = _this$props2.disableCanvasInteraction,
          interactionSettings = _this$props2.interactionSettings;
      var _this$state3 = this.state,
          backgroundGraphics = _this$state3.backgroundGraphics,
          foregroundGraphics = _this$state3.foregroundGraphics,
          projectedXYPoints = _this$state3.projectedXYPoints,
          margin = _this$state3.margin,
          legendSettings = _this$state3.legendSettings,
          adjustedPosition = _this$state3.adjustedPosition,
          adjustedSize = _this$state3.adjustedSize,
          networkFrameRender = _this$state3.networkFrameRender,
          nodeLabelAnnotations = _this$state3.nodeLabelAnnotations,
          overlay = _this$state3.overlay,
          title = _this$state3.title;
      var formattedOverlay;

      if (overlay && overlay.length > 0) {
        formattedOverlay = overlay;
      }

      var activeHoverAnnotation;

      if (Array.isArray(hoverAnnotation)) {
        activeHoverAnnotation = hoverAnnotation;
      } else if (customClickBehavior || customDoubleClickBehavior || customHoverBehavior) {
        activeHoverAnnotation = blankArray;
      } else {
        activeHoverAnnotation = !!hoverAnnotation;
      }

      return React.createElement(_Frame.default, {
        name: "networkframe",
        renderPipeline: networkFrameRender,
        adjustedPosition: adjustedPosition,
        adjustedSize: adjustedSize,
        size: size,
        xScale: xScale,
        yScale: yScale,
        title: title,
        matte: matte,
        className: className,
        additionalDefs: additionalDefs,
        frameKey: "none",
        projectedCoordinateNames: projectedCoordinateNames,
        defaultSVGRule: this.defaultNetworkSVGRule,
        defaultHTMLRule: this.defaultNetworkHTMLRule,
        hoverAnnotation: activeHoverAnnotation,
        annotations: [].concat(_toConsumableArray(annotations), _toConsumableArray(nodeLabelAnnotations)),
        annotationSettings: annotationSettings,
        legendSettings: legendSettings,
        interaction: interaction,
        customClickBehavior: customClickBehavior,
        customHoverBehavior: customHoverBehavior,
        customDoubleClickBehavior: customDoubleClickBehavior,
        points: projectedXYPoints,
        margin: margin,
        overlay: formattedOverlay,
        backgroundGraphics: backgroundGraphics,
        foregroundGraphics: foregroundGraphics,
        beforeElements: beforeElements,
        afterElements: afterElements,
        disableContext: disableContext,
        canvasPostProcess: canvasPostProcess,
        baseMarkProps: baseMarkProps,
        useSpans: !!useSpans,
        canvasRendering: !!(canvasNodes || canvasEdges),
        renderOrder: renderOrder,
        disableCanvasInteraction: disableCanvasInteraction,
        sketchyRenderingEngine: sketchyRenderingEngine,
        frameRenderOrder: frameRenderOrder,
        interactionSettings: interactionSettings
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var props = prevState.props;

      if (prevState.dataVersion && prevState.dataVersion !== nextProps.dataVersion || !prevState.projectedNodes && !prevState.projectedEdges || props.size[0] !== nextProps.size[0] || props.size[1] !== nextProps.size[1] || !prevState.dataVersion && _frame_props.networkFrameChangeProps.find(function (d) {
        return props[d] !== nextProps[d];
      })) {
        return _objectSpread({}, (0, _network.calculateNetworkFrame)(nextProps, prevState), {
          props: nextProps
        });
      }

      return {
        props: nextProps
      };
    }
  }]);

  return NetworkFrame;
}(React.Component);

_defineProperty(NetworkFrame, "defaultProps", {
  annotations: [],
  foregroundGraphics: [],
  annotationSettings: {},
  size: [500, 500],
  className: "",
  name: "networkframe",
  networkType: {
    type: "force",
    iterations: 500
  },
  filterRenderedNodes: function filterRenderedNodes(d) {
    return d.id !== "root-generated";
  }
});

_defineProperty(NetworkFrame, "displayName", "NetworkFrame");

var _default = NetworkFrame;
exports.default = _default;
module.exports = exports.default;